'use client';

import * as a from "react";
import p from "../lib/IconBase.es.js";
import a$1 from "../defs/Smiley.es.js";
const o = a.forwardRef((m, r) => /* @__PURE__ */ a.createElement(p, { ref: r, ...m, weights: a$1 }));
o.displayName = "SmileyIcon";
const s = o;
export {
  s as Smiley,
  o as SmileyIcon
};
